import { Component } from '@angular/core';
import { HomeContainerComponent } from '../home-container/home-container.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    imports: [HomeContainerComponent]
})
export class HomeComponent {}
